import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

let groupkey = 1;
let child = 0;
const Taxes = (props) => {
  // console.log("props", props);
  const [visibleTaxes, setVisibleTaxes] = useState(false);
  const [comingTax, setComingTax] = useState(props.visibleTaxChange);
  // console.log("visibleTaxes", visibleTaxes, " comingTax", comingTax);
  const [rows, setRows] = useState([]);

  console.log(rows, "78874");

  const [formValues, setFormValues] = useState({
    TaxJarAPIKey: "",
    IsTaxunable: false,
    UseTaxJarLocationAPIToPullTaxes: false,
    FlatDiscountAlsoDiscountsTax: false,
    PricesIncludeTax: false,
    ChargeTaxOnReceivings: false,
    UseTaxValuesAtALLLocations: false,
  });
  const [loading, setLoading] = useState(false);
  const [taxgrouparray, setTaxGroupArray] = useState([]);
  const [taxarray, setTaxArray] = useState([]);
  const [counter, setCounter] = useState(0);

  const [data1, setData1] = useState({
    GroupId: 0,
    TaxName: "",
    TaxPercent: 0,
  });

  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const locationid = localStorage.getItem("Location");

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "TaxJarAPIKey", AppConfigvalue: values.TaxJarAPIKey },
      { AppConfigkey: "IsTaxunableKey", AppConfigvalue: values.IsTaxunable },
      {
        AppConfigkey: "UseTaxJarLocationAPIToPullTaxes",
        AppConfigvalue: values.UseTaxJarLocationAPIToPullTaxes,
      },
      {
        AppConfigkey: "FlatDiscountAlsoDiscountsTax",
        AppConfigvalue: values.FlatDiscountAlsoDiscountsTax,
      },
      {
        AppConfigkey: "PricesIncludeTax",
        AppConfigvalue: values.PricesIncludeTax,
      },
      {
        AppConfigkey: "ChargeTaxOnReceivings",
        AppConfigvalue: values.ChargeTaxOnReceivings,
      },
      {
        AppConfigkey: "UseTaxValuesAtALLLocations",
        AppConfigvalue: values.UseTaxValuesAtALLLocations,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "TAXES",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // console.log(1);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    const groupArray = [];
    const taxChildArray = [];

    rows.forEach((row) => {
      // Extracting the desired object for groupArray
      const nameObj = {
        Name: row.Name,
        ID: row.ID,
        Cumulative: row.Cumulative,
        IsDefault: row.IsDefault,
        type: row.type,
      };
      groupArray.push(nameObj);

      // Extracting the desired objects for taxChildArray from childRows
      row.childRows.forEach((childRow) => {
        const taxObj = {
          TaxName: childRow.TaxName,
          GroupId: childRow.GroupId,
          TaxPercent: childRow.TaxPercent,
          type: childRow.type,
        };
        taxChildArray.push(taxObj);
      });
    });

    console.log("groupArray:", taxChildArray, groupArray);

    // Tax Group Xml

    const jsondata = {};
    jsondata.taxgroupsxml = groupArray;

    const jsonxml = {};
    jsonxml.xmltaxgroup = jsondata;

    let jsongroupmodifieddata = JSON.stringify(jsonxml);

    // Tax Xml

    const jsontax = {};
    jsontax.taxxml = taxChildArray;

    const jsontaxes = {};
    jsontaxes.xmltaxes = jsontax;

    let jsontaxmodifieddata = JSON.stringify(jsontaxes);

    // console.log(jsongroupmodifieddata,"jsongroupmodifieddata")
    // console.log(jsontaxmodifieddata,"jsontaxmodifieddata")

    // console.log("workorderitemjsonstring: ", workorderitemjsonstring);
    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/xmlupsertdata`,
        {
          locationid: locationid,
          loginuserid: loginuserid,
          jsongroupData: jsongroupmodifieddata,
          jsontaxdata: jsontaxmodifieddata,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // console.log(1);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //handleChange

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  // useEffect(() => {

  const handleTaxes = () => {
    setLoading(true);

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=TAXES`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "TaxJarAPIKey") {
            formValues.TaxJarAPIKey = data.AppConfigvalue;
          } else if (data.AppConfigkey === "IsTaxunableKey") {
            formValues.IsTaxunable =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "UseTaxJarLocationAPIToPullTaxes") {
            formValues.UseTaxJarLocationAPIToPullTaxes =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "FlatDiscountAlsoDiscountsTax") {
            formValues.FlatDiscountAlsoDiscountsTax =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PricesIncludeTax") {
            formValues.PricesIncludeTax =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ChargeTaxOnReceivings") {
            formValues.ChargeTaxOnReceivings =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "UseTaxValuesAtALLLocations") {
            formValues.UseTaxValuesAtALLLocations =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/storeconfigtextinfo`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        console.log(responseData.taxdata, "responseData");

        const filteredData = responseData.taxdata.map((tax) => {
          const childRows = responseData.subtaxdata
            .filter((subtax) => subtax.GROUP_ID === tax.GROUP_ID)
            .map((subtax) => ({
              TaxName: subtax.Name,
              GroupId: subtax.GROUP_ID,
              TaxPercent: subtax.Percent,
              type: subtax.taxids,
            }));

          return {
            Cumulative: tax.Cumulative || 0,
            ID: tax.GROUP_ID,
            IsDefault: tax.Isdefault || 0, // You can set this value as needed
            Name: tax.Name,
            childRows: childRows,
            type: tax.GROUP_ID,
          };
        });

        console.log(filteredData, "filterdData");
        setRows(filteredData);
        setCounter(filteredData.length);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Code For Table

  const addRow = (e) => {
    console.log(e, rows, "event 197");
    // child=child+1

    const newRow = {
      childRows: [
        {
          GroupId: rows.length + 1,
          TaxName: "",
          TaxPercent: "",
          type: 0,
        },
      ],
      Cumulative: 0,
      ID: rows.length + 1,
      IsDefault: 0,
      Name: "",
      type: 0,
    };
    setRows([...rows, newRow]);
    counter++;

    console.log(rows, "rows1");
    setTaxGroupArray([
      ...taxgrouparray,
      {
        Cumulative: 0,
        ID:
          (taxgrouparray[taxgrouparray.length - 1]?.ID === undefined
            ? 0
            : taxgrouparray[taxgrouparray.length - 1]?.ID) + 1,
        IsDefault: 0,
        Name: "",
      },
    ]);
    setTaxArray([
      ...taxarray,
      {
        GroupId:
          (taxarray[taxarray.length - 1]?.GroupId === undefined
            ? 0
            : taxarray[taxarray.length - 1]?.GroupId) + 1,
        TaxName: "",
        TaxPercent: "",
      },
    ]);
    // setCounter(counter+1)
    // groupkey++;
    child++;
  };

  console.log(rows, "124");

  const handleInputChange = (index, event, field) => {
    if (field === "Cumulative") {
      console.log("event.target.value", event.target.checked);
      // const updatedtaxgroup = [...taxgrouparray];
      // updatedtaxgroup[index][field] = event.target.checked === true ? 1 : 0;
      // setTaxGroupArray(updatedtaxgroup);
      const updatedtaxgroup = [...rows];
      updatedtaxgroup[index][field] = event.target.checked === true ? 1 : 0;
      setRows(updatedtaxgroup);
    } else if (field === "IsDefault") {
      console.log("event.target.value", event.target.checked);

      // const updatedtaxgroup = [...taxgrouparray];
      // updatedtaxgroup[index][field] = event.target.checked === true ? 1 : 0;
      // updatedtaxgroup = updatedtaxgroup.map((item, i) =>
      //   i != index ? (item.IsDefault = 0) : ""
      // );
      // setTaxGroupArray(updatedtaxgroup);

      // const updatedtaxgroup = [...rows];
      // updatedtaxgroup[index][field] = event.target.checked === true ? 1 : 0;
      // updatedtaxgroup = updatedtaxgroup.map((item, i) =>
      //   i != index ? (item.IsDefault = 0) : ""
      // );
      // setRows(updatedtaxgroup);

      const updatedTaxGroup = rows.map((item, i) => {
        if (i === index) {
          item[field] = event.target.checked ? 1 : 0;
        } else {
          item[field] = 0;
        }

        return item;
      });

      setRows(updatedTaxGroup);
    } else {
      // const updatedtaxgroup = [...taxgrouparray];
      // updatedtaxgroup[index][field] = event.target.value;
      // // updatedtaxgroup[index]["ID"] = index + 1;
      // updatedtaxgroup[index]["Cumulative"] = 0;
      // updatedtaxgroup[index]["IsDefault"] = 0;
      // setTaxGroupArray(updatedtaxgroup);
      const updatedtaxgroup = [...rows];
      updatedtaxgroup[index][field] = event.target.value;
      // updatedtaxgroup[index]["ID"] = index + 1;
      setRows(updatedtaxgroup);
    }
  };

  console.log(taxgrouparray, "taxgrouparray");

  const handleChildInputChange = (
    parentIndex,
    childIndex,
    event,
    field,
    row
  ) => {
    console.log(event, "event");
    // console.log(event,pindex,childIndex, "event 456")

    // const updatedChildRows = [...taxarray];
    // updatedChildRows[id][field] = event?.target?.value;
    // // updatedChildRows[id]["GroupId"] = parentIndex + 1;
    // setTaxArray(updatedChildRows);
    const updatedChildRows = [...rows];

    updatedChildRows[parentIndex].childRows[childIndex][field] =
      event?.target?.value;
    // updatedChildRows[id]["GroupId"] = parentIndex + 1;
    setRows(updatedChildRows);
  };

  //  const handlerowdataChange=(parentIndex,e,field)=>{
  //     const updatedChildRows=[...]
  //  }

  // console.log(indexs, "indexs")

  // const handlerowInputChange=(parentIndex, childIndex, event, field)=>{
  //   console.log(indexs, "indexs")
  //   const updatedChildRows = [...taxarray];
  //   updatedChildRows[indexs][field] = event.target.value;
  //   updatedChildRows[indexs]["GroupId"] = parentIndex+1;
  //   setTaxArray(updatedChildRows);
  // }

  console.log(taxgrouparray, taxarray, "taxarray");

  const deleteRow = (parentIndex, row) => {
    console.log(parentIndex, "parentIndex");
    const updatedRows = [...rows];

    // const childRows = updatedRows[parentIndex].childRows;

    // // Delete child rows one by one
    // while (childRows.length > 0) {
    //   childRows.splice(0, 1);
    // }

    // Delete parent row
    // updatedRows.splice(parentIndex, 1);
    const filteredParenttable = updatedRows.filter((el) => el.ID !== row.ID);
    console.log(filteredParenttable, "filteredParenttable");

    setRows(filteredParenttable);
  };

  const childDeleteRow = (parentIndex, childIndex, row) => {
    const updatedRows = [...rows];
    if (parentIndex >= 0 && parentIndex < updatedRows.length) {
      const updatedChildRows = [...updatedRows[parentIndex].childRows];
      if (childIndex >= 0 && childIndex < updatedChildRows.length) {
        const newdata = updatedChildRows.filter(
          (el, ind) => ind !== childIndex
        );

        console.log(newdata, "newdata");
        updatedRows[parentIndex].childRows = newdata;
        setRows(updatedRows);
      }
    }
  };

  // const generateUniqueId = () => {
  //   return Date.now().toString();
  // };

  const addChildRow = (index, row) => {
    const updatedRows = [...rows];

    updatedRows[index].childRows.push({
      GroupId: row.ID,
      TaxName: "",
      TaxPercent: "",
      type: 0,
    });
    // updatedRows[index].childRows["id"]=child
    setRows(updatedRows);
    // child++;
    setTaxArray([
      ...taxarray,
      {
        GroupId: row.ID,
        TaxName: "",
        TaxPercent: "",
        type: 0,
      },
    ]);
  };
  console.log("rowsss::>>", rows);

  // const handleSubmitTaxGroups = () => {
  //   // rows
  //   let WorkOrderItemData = rows.filter(function (workOrderItem) {
  //     return workOrderItem.name != "";
  //   });
  //   const workOrderItemobj = {};
  //   workOrderItemobj.taxgroupsxml = WorkOrderItemData;
  //   let workorderitemjsonstring = JSON.stringify(workOrderItemobj);
  //   console.log("workorderitemjsonstring: ", workorderitemjsonstring);
  //   axios
  //     .post(
  //       `${config.storeConfigBaseUrl}/storeconfig/xmlupsertdata`,
  //       {
  //         jsonData: workorderitemjsonstring,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 0) {
  //         toastSuccess(SUCCESS_MESSAGE);
  //         // console.log(1);
  //       } else {
  //         toastError(ERROR_MESSAGE);
  //       }

  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });
  // };
  // Code For Table

  //Data

  const data = [
    {
      name: "Is Tax unable:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="IsTaxunable"
              name="IsTaxunable"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "TaxJar API Key (US Only):",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="TaxJarAPIKey"
              name="TaxJarAPIKey"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Use TaxJar Location API To Pull Taxes:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="UseTaxJarLocationAPIToPullTaxes"
              name="UseTaxJarLocationAPIToPullTaxes"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Flat Discount Also Discounts Tax:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="FlatDiscountAlsoDiscountsTax"
              name="FlatDiscountAlsoDiscountsTax"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Prices Include Tax:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="PricesIncludeTax"
              name="PricesIncludeTax"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Charge Tax On Receivings:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ChargeTaxOnReceivings"
              name="ChargeTaxOnReceivings"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Use Tax Values At ALL Locations:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="UseTaxValuesAtALLLocations"
              name="UseTaxValuesAtALLLocations"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
  ];

  //Search
  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  console.log(data.length, "datalength");
  console.log(matchesSearchQuery.length, "matchquery");

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  handleTaxes();
                  setVisibleTaxes(!visibleTaxes);
                  setComingTax(!!comingTax);
                }}
                // onChange={() => setVisibleTaxes(props.values)}
              >
                Taxes
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleTaxes || props.visibleTaxChange}>
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                // onSubmit={handleSubmit}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {() => (
                  <Form>
                    <div className="row">
                      <div
                        style={{
                          display: "flex",
                          width: "50%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div
                                style={{
                                  width: "53%",
                                }}
                              >
                                {el.input}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Use TaxJar Location API To Pull Taxes:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UseTaxJarLocationAPIToPullTaxes"
                            name="UseTaxJarLocationAPIToPullTaxes"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Flat Discount Also Discounts Tax:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="FlatDiscountAlsoDiscountsTax"
                            name="FlatDiscountAlsoDiscountsTax"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Prices Include Tax:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PricesIncludeTax"
                            name="PricesIncludeTax"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Charge Tax On Receivings:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ChargeTaxOnReceivings"
                            name="ChargeTaxOnReceivings"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Use Tax Values At ALL Locations:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UseTaxValuesAtALLLocations"
                            name="UseTaxValuesAtALLLocations"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Tax Groups:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <table className="table">
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  ID
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Name
                                </th>
                                {/* <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Tax Name
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Tax Percent
                                </th> */}
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Cumulative
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Default
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Delete
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Add1
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {rows?.map((row, parentIndex) => (
                                <React.Fragment key={parentIndex}>
                                  <tr key={parentIndex} className="mt-3">
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {row?.ID}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={row.Name || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            parentIndex,
                                            e,
                                            "Name"
                                          )
                                        }
                                      />
                                    </td>
                                    {/* <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        // value={row.taxName || ""}
                                        onChange={(e) =>
                                          handleChildInputChange(
                                            parentIndex,
                                            row.id,

                                            e,
                                            "TaxName"
                                          )
                                        }
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        // value={row.taxPercent || ""}
                                        onChange={(e) =>
                                          handleChildInputChange(
                                            parentIndex,
                                            row.id,

                                            e,
                                            "TaxPercent"
                                          )
                                        }
                                      />
                                    </td> */}
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          row.Cumulative === 1 ? true : false
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            parentIndex,
                                            e,
                                            "Cumulative"
                                          )
                                        }
                                      ></input>
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          row.IsDefault === 1 ? true : false
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            parentIndex,
                                            e,
                                            "IsDefault"
                                          )
                                        }
                                      ></input>
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <div
                                        style={{ marginTop: "8px" }}
                                        className="btn btn-primary btn-sm "
                                        onClick={(e) =>
                                          deleteRow(parentIndex, row)
                                        }
                                      >
                                        Delete
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <button
                                        style={{ marginTop: "8px" }}
                                        className="btn btn-primary btn-sm "
                                        type="button"
                                        onClick={() =>
                                          addChildRow(parentIndex, row)
                                        }
                                      >
                                        Add Rate
                                      </button>
                                    </td>

                                    {/* Add more cells based on your requirements */}
                                  </tr>
                                  {row.childRows.map((childRow, childIndex) => (
                                    <tr key={childIndex}>
                                      <td></td>
                                      <td
                                      // style={{
                                      //   textAlign: "center",
                                      //   justifyContent: "center",
                                      // }}
                                      >
                                        <span>Tax Name: </span>{" "}
                                        <input
                                          className="w-10 form-control form-control-sm"
                                          type="text"
                                          value={childRow.TaxName || ""}
                                          onChange={(e) =>
                                            handleChildInputChange(
                                              parentIndex,
                                              childIndex,
                                              e,
                                              "TaxName",
                                              row
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                      // style={{
                                      //   textAlign: "center",
                                      //   justifyContent: "center",
                                      // }}
                                      >
                                        <span>Tax Percent: </span>{" "}
                                        <input
                                          type="text"
                                          className="w-9 form-control form-control-sm"
                                          value={childRow.TaxPercent || ""}
                                          onChange={(e) =>
                                            handleChildInputChange(
                                              parentIndex,
                                              childIndex,
                                              e,
                                              "TaxPercent",
                                              row
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <div
                                          className="btn btn-link"
                                          onClick={(e) =>
                                            childDeleteRow(
                                              parentIndex,
                                              childIndex
                                            )
                                          }
                                        >
                                          X
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))}
                            </tbody>
                            <div
                              style={{ marginTop: "8px" }}
                              className="btn btn-primary btn-sm  "
                              onClick={(e) => addRow(e)}
                            >
                              Add
                            </div>
                          </table>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleTaxes(!visibleTaxes);
                    setComingTax(!!comingTax);
                  }}
                  // onChange={() => setVisibleTaxes(props.values)}
                >
                  Taxes
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleTaxes || props.visibleTaxChange}>
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  // onSubmit={handleSubmit}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Use TaxJar Location API To Pull Taxes:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UseTaxJarLocationAPIToPullTaxes"
                            name="UseTaxJarLocationAPIToPullTaxes"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                      <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Flat Discount Also Discounts Tax:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="FlatDiscountAlsoDiscountsTax"
                            name="FlatDiscountAlsoDiscountsTax"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                      <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Prices Include Tax:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PricesIncludeTax"
                            name="PricesIncludeTax"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                      <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Charge Tax On Receivings:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ChargeTaxOnReceivings"
                            name="ChargeTaxOnReceivings"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                      <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Use Tax Values At ALL Locations:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UseTaxValuesAtALLLocations"
                            name="UseTaxValuesAtALLLocations"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="form-group row">
                        <div className="col-md-6">
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                <label
                                  className="col-form-label"
                                  style={{ fontSize: "15px" }}
                                >
                                  {el.name}
                                </label>
                                <div>{el.input}</div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-form-label col-lg-2 ">
                          Tax Groups:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Name
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Tax Name
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Tax Percent
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Cumulative
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Default
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Delete
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Add
                                  </th>
                                  <th
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    ID
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows?.map((row, parentIndex) => (
                                  <React.Fragment key={parentIndex}>
                                    <tr key={parentIndex} className="mt-3">
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          value={row.Name || ""}
                                          onChange={(e) =>
                                            handleInputChange(
                                              parentIndex,
                                              e,
                                              "Name"
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          value={row.taxName || ""}
                                          onChange={(e) =>
                                            handleInputChange(
                                              parentIndex,
                                              e,
                                              "taxName"
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          value={row.taxPercent || ""}
                                          onChange={(e) =>
                                            handleInputChange(
                                              parentIndex,
                                              e,
                                              "taxPercent"
                                            )
                                          }
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            handleInputChange(
                                              parentIndex,
                                              e,
                                              "Cumulative"
                                            )
                                          }
                                        ></input>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="Default"
                                          onChange={(e) =>
                                            handleInputChange(
                                              parentIndex,
                                              e,
                                              "Default"
                                            )
                                          }
                                        ></input>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          style={{ marginTop: "8px" }}
                                          className="btn btn-primary btn-sm "
                                          onClick={() => deleteRow(parentIndex)}
                                        >
                                          Delete
                                        </button>
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          style={{ marginTop: "8px" }}
                                          className="btn btn-primary btn-sm"
                                          type="button"
                                          onClick={() =>
                                            addChildRow(parentIndex)
                                          }
                                        >
                                          Add Rate
                                        </button>
                                      </td>
                                      {/* Add more cells based on your requirements */}
                                    </tr>
                                    {rows.childRows?.map(
                                      (childRow, childIndex) => (
                                        <tr key={childIndex}>
                                          <td></td>
                                          <td
                                            style={{
                                              textAlign: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              // value={childRow.TaxName || ""}
                                              onChange={(e) =>
                                                handleChildInputChange(
                                                  parentIndex,
                                                  childRow.id,
                                                  e,
                                                  "TaxName"
                                                )
                                              }
                                            />
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              // value={childRow.TaxPercent || ""}
                                              onChange={(e) =>
                                                handleChildInputChange(
                                                  parentIndex,
                                                  childRow.id,
                                                  e,
                                                  "TaxPercent"
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                            <div
                              className="btn btn-link "
                              onClick={(e) => addRow(e)}
                            >
                              Add
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default Taxes;
